module.exports = __webpack_public_path__ + "img/5.3b6b62ce.png";